var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard__card" },
    [
      _vm.loaders.vendors ? _c("CardLoading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dashboard__card-content",
          class: { loadingBlur: _vm.loaders.vendors }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "row dashboard__card-body" }, [
            _vm.pricingVendors
              ? _c(
                  "div",
                  {
                    staticClass:
                      "dashboard__grid dash-library__content-container"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 dashboard__card-body-col dashboard__card-body-col--bordered"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "dash-library__list" },
                          _vm._l(_vm.pricingVendors, function(document, index) {
                            return _c("Document", {
                              key: index,
                              attrs: { document: document }
                            })
                          }),
                          1
                        )
                      ]
                    )
                  ]
                )
              : _c(
                  "div",
                  {
                    staticClass:
                      "dashboard__grid dashboard__alert alert alert-warning"
                  },
                  [
                    _c("div", { staticClass: "dashboard__no-data" }, [
                      _vm._v("No pricing information available")
                    ])
                  ]
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard__card-footer" }, [
            _vm.pricingVendors
              ? _c(
                  "div",
                  { staticClass: "dashboard__card-link" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "dashboard__card-link-text",
                        attrs: { to: "/pricing-guides" }
                      },
                      [_vm._v("Browse Pricing Guides")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dashboard__card-header" }, [
      _c("div", { staticClass: "dashboard__card-title" }, [
        _vm._v("Pricing Guides")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "dashboard__card-title-icon dashboard__card-title-icon--library"
        },
        [_c("i", { staticClass: "fa fa-file" })]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }